'use strict';

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _wrapNativeSuper = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapNativeSuper");

var ExPeerNotFound = require('./exceptions/expeernotfound.js');
/**
 * Structure containing the neighborhood of a peer.
 * Map of {idPeer => [age_1, age_2.. age_k]} where age_1 <= age_2 <= .. <= age_k
 */


var PartialView =
/*#__PURE__*/
function (_Map) {
  _inherits(PartialView, _Map);

  function PartialView() {
    _classCallCheck(this, PartialView);

    return _possibleConstructorReturn(this, _getPrototypeOf(PartialView).apply(this, arguments));
  }

  _createClass(PartialView, [{
    key: "increment",

    /**
       * Increment the age of the whole partial view
       */
    value: function increment() {
      var _this = this;

      this.forEach(function (ages, peerId) {
        _this.set(peerId, ages.map(function (age) {
          return age + 1;
        }));
      });
    }
  }, {
    key: "add",

    /**
       * Add the peer to the partial view with an age of 0.
       * @param {string} peerId The identifier of the peer added to the partial
       * view.
       */
    value: function add(peerId) {
      !this.has(peerId) && this.set(peerId, []);
      this.get(peerId).unshift(0); // add 0 in front of the array
    }
  }, {
    key: "removeYoungest",

    /**
       * Remove the newest entry of the peer from the partial view.
       * @param {string} peerId The identifier of the peer to remove from the
       * partial view.
       */
    value: function removeYoungest(peerId) {
      if (!this.has(peerId)) {
        throw new ExPeerNotFound('removeYoungest', peerId);
      }

      ;
      this.get(peerId).shift();
      this.get(peerId).length === 0 && this.delete(peerId);
    }
  }, {
    key: "removeOldest",

    /**
       * Remove the oldest entry of the peer from the partial view.
       * @param {string} peerId The identifier of the peer to remove from the
       * partial view.
       */
    value: function removeOldest(peerId) {
      if (!this.has(peerId)) {
        throw new ExPeerNotFound('removeOldest', peerId);
      }

      ;
      this.get(peerId).pop();
      this.get(peerId).length === 0 && this.delete(peerId);
    }
  }, {
    key: "removeAll",

    /**
       * Remove all entries of the peer from the partial view.
       * @param {string} peerId The identifier of the peer to remove from the
       * partial view.
       * @returns {number} The number of occurrences of peerId removed.
       */
    value: function removeAll(peerId) {
      if (!this.has(peerId)) {
        throw new ExPeerNotFound('removeAll', peerId);
      }

      ;
      var occ = this.get(peerId).length;
      this.delete(peerId);
      return occ;
    }
  }, {
    key: "oldest",

    /**
       * Get the oldest peer in the partial view.
       * @returns {string} The oldest peer in the array.
       */
    get: function get() {
      if (this.size <= 0) {
        throw new ExPeerNotFound('oldest');
      }

      ;
      var oldestPeer = null;
      var oldestAge = 0;
      this.forEach(function (ages, peerId) {
        if (oldestAge <= ages[ages.length - 1]) {
          oldestPeer = peerId;
          oldestAge = ages[ages.length - 1];
        }

        ;
      });
      return oldestPeer;
    }
  }, {
    key: "leastFrequent",

    /**
       * Get the least frequent peer. If multiple peers have the same number of
       * occurrences, it chooses one among them at random.
       * @returns {string} The identifier of a least frequent peer.
       */
    get: function get() {
      var leastFrequent = [];
      var frequency = Infinity;
      this.forEach(function (ages, peerId) {
        if (ages.length < frequency) {
          leastFrequent = [];
          frequency = ages.length;
        }

        ;
        ages.length === frequency && leastFrequent.push(peerId);
      });
      return leastFrequent[Math.floor(Math.random() * leastFrequent.length)];
    }
  }]);

  return PartialView;
}(_wrapNativeSuper(Map));

module.exports = PartialView;